import React, { useState, useEffect } from "react";
import "./Teacher_Form.css";
import drag_drop from "../../../assets/drag_drop.png";
import calendar from "../../../assets/calendar.png";
import cancel from "../../../assets/cancel.png";
import DeleteCard from "../../Cards/DeleteCard/DeleteCard";
import Loader from "../../Loader/Loader";
import { storage } from "../../../firebase";
import { toast } from "react-hot-toast";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import api from "../../../utils/api";

const Teacher_Form = (props) => {
  const [details, setDetails] = useState({
    email: "",
    id: 0,
    name: "",
    password: "",
    phone: "",
    teacher_id: "",
  });
  const [loading, setLoading] = useState(0);

  const isEdit = props.isEdit;
  const data = props.data;

  const handleClick2 = () => {
    props.setDisp();
    props.setEdit();
  };

  const [considering, setConsidering] = useState([]);

  useEffect(() => {
    setDetails(data);
  }, [isEdit]);

  const handleChange = (e) => {
    setDetails({
      ...details,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(1);

    // const response = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher`, {
    //   method: "PATCH",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(details),
    // }).then(() => {
    //   setLoading(0);
    // });
    try {
      await api.put("/teachers", details);
      setLoading(0);
      props.setDisp();
      props.onSuccess();
      toast.success("Teacher updated successfully");
    } catch (error) {
      console.error("Error updating student details:", error);
      // Optionally handle specific error responses here
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={"circular__form_div_open"}>
        <div className="circular__form teacher__form">
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
          <h1 style={{padding: '0', margin: '0', fontSize: '24px'}}>Edit Teacher</h1>
          <div className="circular__from_img" onClick={handleClick2}>
            <img src={cancel} alt="cancel" />
          </div>
            
          </div>
          <div className="circular__form_input">
            <h5> Teacher Id</h5>
            <input
              required
              type="text"
              name="teacher_id"
              readOnly
              disabled
              // onChange={handleChange}
              // defaultValue={isEdit ? data.title : null}
              defaultValue={data.teacher_id}
              className="circular__form_input_small"
            />
          </div>
          <div className="circular__form_input">
            <h5> Name</h5>
            <input
              required
              type="text"
              name="name"
              onChange={handleChange}
              defaultValue={data.name}
              className="circular__form_input_small"
            />
          </div>
          <div className="circular__form_input">
            <h5> Surname</h5>
            <input
              required
              type="text"
              name="surname"
              onChange={handleChange}
              defaultValue={data.surname}
              className="circular__form_input_small"
            />
          </div>
          <div className="circular__form_input">
            <h5> Email</h5>
            <input
              required
              type="email"
              name="email"
              onChange={handleChange}
              defaultValue={data.email}
              className="circular__form_input_small"
            />
          </div>
          <div className="circular__form_input">
            <h5> Phone</h5>
            <input
              required
              type="text"
              name="phone"
              onChange={handleChange}
              defaultValue={data.phone}
              className="circular__form_input_small"
            />
          </div>
          <div className="circular__form_input">
            <h5> Gender</h5>
            <input
              required
              type="text"
              name="gender"
              onChange={handleChange}
              defaultValue={data.gender}
              className="circular__form_input_small"
            />
          </div>
          <div>
            {
              loading ? (
                <p style={{ color: "#fff" }}>
                  <Loader small={true} />
                </p>
              ) : (
                <button className="circular__form_button" type="Submit">
                  <span style={{ color: "#fff" }}>Edit Teacher</span>
                </button>
              )
              // <p style={{ color: "#fff" }}>Add circular</p>
            }
          </div>
        </div>
      </div>
    </form>
  );
};

export default Teacher_Form;
